import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import api from "@/api";

// Replace with your actual Firebase project configuration
const firebaseConfig = {
    apiKey: "YOUR_API_KEY",
    authDomain: "YOUR_AUTH_DOMAIN",
    projectId: "YOUR_PROJECT_ID",
    storageBucket: "YOUR_STORAGE_BUCKET",
    messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
    appId: "YOUR_APP_ID"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestNotificationPermission = async (userId) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: "YOUR_PUBLIC_VAPID_KEY" // Add your VAPID key from Firebase console
            });

            if (token && userId) {
                // Send token to backend to associate with user
                await api.put(`/user/${userId}/fcm-token`, { fcmToken: token });
                console.log("FCM Token registered.");
            }
        }
    } catch (error) {
        console.error("Error requesting notification permission:", error);
    }
};

export const onForegroundMessage = () => {
    onMessage(messaging, (payload) => {
        console.log("Message received in foreground:", payload);
        // You can use a toast library here to show a notification
    });
};
